<script setup lang="ts">
// @ts-nocheck
import { nextTick, onMounted, ref } from 'vue'
import { v4 as uuidv4 } from 'uuid'

import { isTablet } from 'mobile-device-detect'
import { useUserStore } from '@/stores/user'
import { GetChatList, GetMessageListByUser, UploadFile } from '@/services/mentor/Mentor'
import BaykusButton from '@/components/UIComponents/BaykusButton/BaykusButton.vue'
import BaykusAvatar from '@/components/BaykusAvatar/BaykusAvatar.vue'
import { useSignalR } from '@/composables/useSignalR'
import { DateTime } from 'luxon'
import ChatItem from '@/components/BaykusChat/ChatItem.vue'
import { useImageCompressor } from '@/composables/useImageCompressor'
const { SendMessage, listenToMessages, SendMessageACK } = useSignalR()
const { getUserData } = useUserStore()
const openList = ref(false)
const loadingChatBox = ref('')

export interface Id {
  timestamp: number
  machine: number
  pid: number
  increment: number
  creationTime: string
}
export interface ConversationId {
  timestamp: number
  machine: number
  pid: number
  increment: number
  creationTime: string
}

type CHAT = {
  id: Id
  conversationId: ConversationId
  senderId: string
  receiverId: string
  studentId: string
  content: string
  profilePhoto: string
  studentFullName: string
  lastMessage: string
  lastMessageOwner: string
  lastMessageDate: string
  systemMessage: SystemMessage | null
  timestamp: string
  position: string
  messagesList: any[]
  message?: string | null
  isOpenUploadLine: boolean
}
type CHATList = {
  studentId: string
  profilePhoto: string
  studentFullName: string
  lastMessage: string
  lastMessageOwner: string
  lastMessageDate: string
  systemMessage: SystemMessage | null
}

interface ChatBoxes {
  [key: string]: HTMLElement
}
interface MessageId {
  timestamp: number
  machine: number
  pid: number
  increment: number
  creationTime: string
}

interface SystemMessage {
  systemMessageType: 'SpecifiedHour'
  textForSender: string
  textForReceiver: string
  invitationId: string
  date: string
  time: string
  invitationType: 'VoiceCall' | 'VideoCall'
  excuse: string | null
}

interface Message {
  id: MessageId
  senderId: string
  conversationId: MessageId
  receiverId: string
  content: string
  timestamp: string
  systemMessage: SystemMessage | null
}

type Messages = {
  [key: string]: Message[]
}

const toggleList = () => {
  openList.value = !openList.value
}
const activePage = ref(1)
const maxPage = ref(0)
const selectedChatId = ref<string | null>(null)
const search = ref<string | null>()
const chatBoxes = ref<ChatBoxes>({})
const chatBox = ref<HTMLElement[]>([])
const isLoadingUpload = ref('-1')
const { compressImage, compressedImage, isCompressing, error } = useImageCompressor()
const imageInput = ref<HTMLInputElement | null>(null)
const selectedChat = ref<CHAT[]>([])
const selectedFile = ref<File | null>(null)
const messagesList = ref<CHATList[]>([])
const chatsMessages = ref<Messages>({})
const windowWidth = ref(window.innerWidth)
const togglePositionSelectedChat = (item: CHAT) => {
  const chat = selectedChat.value.find((chat) => chat.studentId === item.studentId)
  if (chat) {
    chat.position = chat.position === 'open' ? 'close' : 'open'
  }
  if (chat?.position === 'open') {
    nextTick(() => {
      chatBox.value.forEach((chatBox) => {
        if (chatBox.getAttribute('data-id') === chat.studentId) {
          nextTick(() => {
            chatBox.scrollTop = chatBox.scrollHeight
          })
        }
      })
    })
  }
}
const onSearch = () => {
  if (search.value) {
    if (search.value?.length >= 3) {
      activePage.value = 1
      getChatList(false)
    }
  } else {
    activePage.value = 1
    getChatList(false)
  }
}
const removeChatList = (id: string) => {
  selectedChat.value = selectedChat.value.filter((chat) => chat.studentId !== id)
  console.log(selectedChat.value)
}

const getChatList = async (isPaging = false) => {
  try {
    const response = await GetChatList(activePage.value, search.value as string)
    maxPage.value = response.data.totalPages

    if (isPaging) {
      messagesList.value = [...messagesList.value, ...response.data.data]
    } else {
      messagesList.value = response.data.data
    }
  } catch (e) {
    console.log(e)
  }
}

const getMessages = async (id: string, paging = false) => {
  try {
    if (!paging) loadingChatBox.value = id
    let pagingChatBox: HTMLElement = chatBoxes.value[id]
    let currentScrollHeight = 0
    let currentScrollTop = 0
    if (pagingChatBox) {
      currentScrollHeight = pagingChatBox.scrollHeight || 0
      currentScrollTop = pagingChatBox.scrollTop || 0
    }
    let date = null
    if (chatsMessages.value[id] && paging) {
      date = chatsMessages.value[id][0].timestamp
    }
    const response = await GetMessageListByUser(id, date, null)
    if (!paging) {
      chatsMessages.value[id] = [...response.data.reverse()]
    } else {
      chatsMessages.value[id] = [...response.data.reverse(), ...chatsMessages.value[id]]
    }
    loadingChatBox.value = ''

    if (!paging) {
      await nextTick()
      chatBox.value[chatBox.value?.length - 1].scrollTop =
        chatBox.value[chatBox.value.length - 1].scrollHeight
    }
    if (paging) {
      await nextTick()
      pagingChatBox.scrollTop = pagingChatBox.scrollHeight - currentScrollHeight + currentScrollTop
    }
    return response
  } catch (e) {
    console.log(e)
    return null
  } finally {
    loadingChatBox.value = ''
  }
}

const onClickChatPopup = async (item: CHATList) => {
  selectedFile.value = null
  let newItem = {
    ...item,
    position: 'open',
    message: null,
    isOpenUploadLine: false
  }

  const isHave = selectedChat.value.findIndex((chat) => chat.studentId === item.studentId)
  if (isHave !== -1) {
    selectedChat.value[isHave].position = 'open'
  } else {
    // if (selectedChat.value.length === (windowWidth.value < 1300 ? 1 : 2)) {
    //   selectedChat.value.shift()
    // }
    // selectedChat.value.push(newItem as CHAT)
    selectedChat.value = [newItem]
  }
  await getMessages(item.studentId, false)
}

const onScroll = (event: Event) => {
  const target = event.target as HTMLElement
  if (target.scrollTop + target.clientHeight >= target.scrollHeight) {
    if (activePage.value === maxPage.value) return
    activePage.value = activePage.value + 1
    getChatList(true)
  }
}
const onListenNewMessage = async () => {
  try {
    let response = await GetChatList(1, null)
    return response.data.data[0]
  } catch (e) {
    console.log(e)
  }
}
const listenMessage = async (x: any) => {
  console.log(x)
  if (x.receiverId === getUserData.value?.id) {
    const chat = messagesList.value.find((chat) => chat.studentId === x.senderId)
    const isHaveOpenChat = selectedChat.value.findIndex((chat) => chat.studentId === x.senderId)

    if (chat) {
      chat.lastMessage = x.message
      chat.lastMessageOwner = x.senderId
      chat.lastMessageDate = x.timestamp
      chat.systemMessage = x.systemMessage
    } else {
      if (!search.value) {
        let newChat = await onListenNewMessage()
        messagesList.value = [newChat, ...messagesList.value]
      }
    }

    if (isHaveOpenChat !== -1) {
      chatBox.value.forEach((chatBox) => {
        if (chatBox.getAttribute('data-id') === x.senderId) {
          // Check if scroll is at the bottom
          const isScrollAtBottom = chatBox.scrollTop === chatBox.scrollHeight - chatBox.clientHeight

          chatsMessages.value[x.senderId].push({
            ...x,
            content: x.message
          })

          // Only scroll to bottom if already at bottom
          if (isScrollAtBottom) {
            nextTick(() => {
              chatBox.scrollTop = chatBox.scrollHeight
            })
          }
        }
      })
    }
  }
  if (x.senderId === getUserData.value?.id) {
    const chat = messagesList.value.find((chat) => chat.studentId === x.receiverId)
    const isHaveOpenChat = selectedChat.value.findIndex((chat) => chat.studentId === x.receiverId)
    if (chat) {
      chat.lastMessage = x.message
      chat.lastMessageOwner = x.senderId
      chat.lastMessageDate = x.timestamp
      chat.systemMessage = x.systemMessage
    } else {
      if (!search.value) {
        let newChat = await onListenNewMessage()
        messagesList.value = [newChat, ...messagesList.value]
      }
    }
    if (isHaveOpenChat !== -1) {
      chatsMessages.value[x.receiverId].push({
        ...x,
        content: x.message
      })
    }
    chatBox.value.forEach((chatBox) => {
      if (chatBox.getAttribute('data-id') === x.receiverId) {
        nextTick(() => {
          chatBox.scrollTop = chatBox.scrollHeight
        })
      }
    })
  }
}
const listenSendMessageACK = (message: string, messageId: string) => {
  console.log('deneme')
  console.log(messageId, message)
}
const onOpenImageSelected = (chatId: string) => {
  if (!imageInput.value) return
  selectedChatId.value = chatId
  imageInput.value.click()
}
const onSelectImage = async (event: Event) => {
  const target = event.target as HTMLInputElement
  const file = target.files?.[0]
  if (!file) {
    return (selectedChatId.value = null)
  }
  selectedFile.value = file
}
const onUploadFile = async () => {
  try {
    isLoadingUpload.value = selectedChatId.value
    let compressedFile = await compressImage(selectedFile.value)
    console.log(selectedChatId.value)
    let formData = new FormData()
    formData.append('file', compressedFile)
    let response = await UploadFile(formData)
    let messageId = uuidv4()
    let content = {
      contentType: response.data.fileContentType,
      fileUrl: response.data.fileUrl,
      previewUrl: response.data.previewUrl,
      previewDimensions: response.data.previewDimensions
    }
    SendMessage(messageId, selectedChatId.value, '', content)
    listenMessage({
      messageId: messageId,
      receiverId: selectedChatId.value,
      senderId: getUserData.value?.id,
      message: '',
      timestamp: DateTime.now().toISO(),
      mediaAttachment: content
    })
  } catch (e) {
    console.log(e)
  } finally {
    selectedFile.value = null
    isLoadingUpload.value = '-1'
    imageInput.value.value = null
    loadingChatBox.value = ''
    selectedChat.value.forEach((chat) => {
      if (chat.studentId === selectedChatId.value) {
        chat.isOpenUploadLine = false
        selectedChatId.value = null
      }
    })
  }
}
const onScrollUserChat = (event: Event, studentId: string) => {
  const target = event.target as HTMLElement
  const chatBox = event.target
  chatBoxes.value[studentId] = chatBox as HTMLElement
  if (target.scrollTop === 0) {
    console.log(studentId)
    getMessages(studentId, true)
  }
}
const messageSend = (studentId: string) => {
  if (selectedFile.value) {
    return onUploadFile()
  }
  let chat = selectedChat.value.findIndex((chat) => chat.studentId === studentId)
  if (chat === -1) return
  if (!selectedChat.value[chat].message) return
  let messageId = uuidv4()
  SendMessage(messageId, studentId, selectedChat.value[chat].message as string, {})
  listenMessage({
    messageId: messageId,
    receiverId: studentId,
    senderId: getUserData.value?.id,
    message: selectedChat.value[chat].message as string,
    timestamp: DateTime.now().toISO()
  })
  selectedChat.value[chat].message = null
}
const removeSelectedFile = (studentId: string) => {
  if (isLoadingUpload.value === selectedChatId.value) return
  selectedFile.value = null
  selectedChatId.value = null
  imageInput.value.value = null
  selectedChat.value.forEach((chat) => {
    if (chat.studentId === studentId) {
      chat.isOpenUploadLine = false
    }
  })
}
onMounted(async () => {
  await getChatList()
  SendMessageACK(listenSendMessageACK)
  listenToMessages(listenMessage)
})
</script>

<template>
  <div class="flex justify-end items-end gap-4">
    <input
      ref="imageInput"
      type="file"
      accept="image/png, image/jpeg, image/jpg"
      class="hidden"
      @change="onSelectImage"
    />
    <div class="flex items-end flex-1 chat-list max-w-[1200px] gap-3 justify-end overflow-x-auto">
      <div
        v-for="chat in selectedChat"
        :key="chat.studentId"
        class="bg-gray-50 rounded-tl-xl rounded-tr-xl shadow-xl border border-gray-200 w-[350px]"
      >
        <div class="cursor-pointer flex items-center justify-between border-b border-b-gray-200">
          <div
            @click.prevent="togglePositionSelectedChat(chat)"
            class="flex px-4 py-3 items-center gap-3"
          >
            <BaykusAvatar :src="chat.profilePhoto" width="40" height="40" />
            <h2 class="text-base font-semibold text-gray-700">{{ chat.studentFullName }}</h2>
          </div>
          <div class="flex items-center gap-2">
            <div
              @click.prevent="togglePositionSelectedChat(chat)"
              :class="{ 'rotate-180': chat.position === 'open' }"
              class="py-3 text-gray-700"
            >
              <svg
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.5 16.25L13 9.75L19.5 16.25"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <div @click.prevent="removeChatList(chat.studentId)" class="pr-4 py-3 text-gray-700">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.0059 16.2441L15.0059 16.2441C15.1703 16.4085 15.3933 16.5009 15.6258 16.5009C15.8583 16.5009 16.0813 16.4085 16.2457 16.2441C16.4101 16.0797 16.5024 15.8567 16.5024 15.6242C16.5024 15.3918 16.4101 15.1688 16.2457 15.0044C16.2457 15.0044 16.2457 15.0044 16.2457 15.0044L11.284 10.0442L11.2398 10L11.2839 9.95584L16.2441 4.99412L16.2441 4.99411C16.4085 4.82971 16.5009 4.60674 16.5009 4.37425C16.5009 4.14175 16.4085 3.91878 16.2441 3.75438C16.0797 3.58998 15.8567 3.49762 15.6242 3.49762C15.3917 3.49762 15.1688 3.58998 15.0044 3.75438L10.0442 8.71609L10 8.76029L9.95583 8.7161L4.99411 3.75595L4.9941 3.75594C4.8297 3.59154 4.60673 3.49918 4.37423 3.49918C4.14174 3.49918 3.91876 3.59154 3.75437 3.75594C3.58997 3.92034 3.49761 4.14331 3.49761 4.37581C3.49761 4.6083 3.58996 4.83127 3.75436 4.99567C3.75436 4.99567 3.75436 4.99567 3.75437 4.99568L8.71608 9.95583L8.76029 10L8.71608 10.0442L3.75358 15.0059C3.58918 15.1703 3.49683 15.3933 3.49683 15.6258C3.49683 15.8583 3.58918 16.0813 3.75358 16.2457C3.91798 16.4101 4.14096 16.5024 4.37345 16.5024C4.60595 16.5024 4.82892 16.4101 4.99332 16.2457L5.03751 16.2899L4.99332 16.2457L9.95582 11.284L10 11.2398L10.0442 11.284L15.0059 16.2441Z"
                  fill="currentColor"
                  stroke="currentColor"
                  stroke-width="0.125"
                />
              </svg>
            </div>
          </div>
        </div>
        <div v-if="chat.position === 'open'">
          <div
            @scroll="(event) => onScrollUserChat(event, chat.studentId)"
            :data-id="chat.studentId"
            class="h-[350px] overflow-y-auto px-4 py-2"
            ref="chatBox"
          >
            <div
              v-if="loadingChatBox === chat.studentId"
              class="flex items-center justify-center h-full"
            >
              <div role="status">
                <svg
                  aria-hidden="true"
                  class="inline w-8 h-8 text-gray-300 animate-spin dark:text-gray-600 fill-gray-50"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <template v-else v-for="item in chatsMessages[chat.studentId]" :key="item.timestamp">
              <ChatItem :message="item" :chat="chat" />
            </template>
          </div>

          <div v-if="loadingChatBox !== chat.studentId" class="px-4 py-2">
            <div
              class="bg-gray-200 py-[4px] px-[8px] rounded-xl flex gap-4 items-center"
              v-if="selectedFile && selectedChatId === chat.studentId"
            >
              <div
                class="bg-gray-100 p-[8px] rounded-full max-w-full w-fit flex items-center gap-2"
              >
                <svg
                  v-if="selectedFile.type.includes('image')"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.8432 19C4.61949 18.9998 4.40502 18.9125 4.24692 18.7573C4.08881 18.6022 4 18.3918 4 18.1725V4.8275C4.00156 4.60865 4.09087 4.39918 4.24864 4.24435C4.40641 4.08951 4.61997 4.00175 4.8432 4H20.1568C20.6226 4 21 4.37083 21 4.8275V18.1725C20.9984 18.3914 20.9091 18.6008 20.7514 18.7557C20.5936 18.9105 20.38 18.9983 20.1568 19H4.8432ZM19.3 14V5.66667H5.7V17.3333L14.2 9L19.3 14ZM19.3 16.3567L14.2 11.3567L8.1038 17.3333H19.3V16.3567ZM9.1 10.6667C8.64913 10.6667 8.21673 10.4911 7.89792 10.1785C7.57911 9.86595 7.4 9.44203 7.4 9C7.4 8.55797 7.57911 8.13405 7.89792 7.82149C8.21673 7.50893 8.64913 7.33333 9.1 7.33333C9.55087 7.33333 9.98327 7.50893 10.3021 7.82149C10.6209 8.13405 10.8 8.55797 10.8 9C10.8 9.44203 10.6209 9.86595 10.3021 10.1785C9.98327 10.4911 9.55087 10.6667 9.1 10.6667Z"
                    fill="black"
                  />
                </svg>

                <p class="text-gray-700 font-medium text-md">{{ selectedFile.name }}</p>
                <div @click="removeSelectedFile(chat.studentId)" class="cursor-pointer">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.7042 17.2907C18.892 17.4784 18.9975 17.7331 18.9975 17.9987C18.9975 18.2643 18.892 18.5189 18.7042 18.7067C18.5164 18.8945 18.2618 19 17.9962 19C17.7306 19 17.4759 18.8945 17.2882 18.7067L11.9996 13.4165L6.70934 18.7051C6.52156 18.8928 6.26687 18.9983 6.00131 18.9983C5.73574 18.9983 5.48106 18.8928 5.29328 18.7051C5.10549 18.5173 5 18.2626 5 17.997C5 17.7315 5.10549 17.4768 5.29328 17.289L10.5835 12.0004L5.29494 6.71017C5.10716 6.52239 5.00167 6.2677 5.00167 6.00214C5.00167 5.73658 5.10716 5.48189 5.29494 5.29411C5.48272 5.10633 5.73741 5.00083 6.00297 5.00083C6.26854 5.00083 6.52322 5.10633 6.71101 5.29411L11.9996 10.5844L17.2898 5.29328C17.4776 5.10549 17.7323 5 17.9979 5C18.2634 5 18.5181 5.10549 18.7059 5.29328C18.8937 5.48106 18.9992 5.73574 18.9992 6.00131C18.9992 6.26687 18.8937 6.52156 18.7059 6.70934L13.4156 12.0004L18.7042 17.2907Z"
                      fill="#ED3B3B"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div
              v-if="chat.isOpenUploadLine && !selectedFile"
              class="bg-gray-200 py-[8px] px-[16px] rounded-xl flex gap-4 items-center"
            >
              <div @click="chat.isOpenUploadLine = false" class="cursor-pointer">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 6L9 12L15 18"
                    stroke="#5E36FE"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
              <div
                @click="onOpenImageSelected(chat.studentId)"
                class="flex cursor-pointer items-center flex-col"
              >
                <div class="w-[24px] h-[24px]">
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_4058_1691)">
                      <path
                        d="M10.69 6.16667L9.02335 7.83333H5.83335V17.8333H19.1667V7.83333H15.9767L14.31 6.16667H10.69ZM10 4.5H15L16.6667 6.16667H20C20.221 6.16667 20.433 6.25446 20.5893 6.41074C20.7456 6.56702 20.8334 6.77899 20.8334 7V18.6667C20.8334 18.8877 20.7456 19.0996 20.5893 19.2559C20.433 19.4122 20.221 19.5 20 19.5H5.00002C4.77901 19.5 4.56704 19.4122 4.41076 19.2559C4.25448 19.0996 4.16669 18.8877 4.16669 18.6667V7C4.16669 6.77899 4.25448 6.56702 4.41076 6.41074C4.56704 6.25446 4.77901 6.16667 5.00002 6.16667H8.33335L10 4.5ZM12.5 17C11.2844 17 10.1187 16.5171 9.25911 15.6576C8.39957 14.798 7.91669 13.6322 7.91669 12.4167C7.91669 11.2011 8.39957 10.0353 9.25911 9.17576C10.1187 8.31622 11.2844 7.83333 12.5 7.83333C13.7156 7.83333 14.8814 8.31622 15.7409 9.17576C16.6005 10.0353 17.0834 11.2011 17.0834 12.4167C17.0834 13.6322 16.6005 14.798 15.7409 15.6576C14.8814 16.5171 13.7156 17 12.5 17ZM12.5 15.3333C13.2736 15.3333 14.0154 15.026 14.5624 14.4791C15.1094 13.9321 15.4167 13.1902 15.4167 12.4167C15.4167 11.6431 15.1094 10.9013 14.5624 10.3543C14.0154 9.80729 13.2736 9.5 12.5 9.5C11.7265 9.5 10.9846 9.80729 10.4376 10.3543C9.89064 10.9013 9.58335 11.6431 9.58335 12.4167C9.58335 13.1902 9.89064 13.9321 10.4376 14.4791C10.9846 15.026 11.7265 15.3333 12.5 15.3333Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4058_1691">
                        <rect width="20" height="20" fill="white" transform="translate(2.5 2)" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <p class="text-gray-700 font-medium text-sm">Fotoğraf</p>
              </div>
              <div class="hidden items-center flex-col">
                <svg
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.16666 4.70001H15.5V8.1H18.8333V18.3H7.16666V4.70001ZM6.3325 3.00001C6.22354 2.99956 6.11557 3.02102 6.01474 3.06316C5.91392 3.10531 5.82223 3.16731 5.74492 3.24562C5.6676 3.32392 5.60618 3.41701 5.56415 3.51955C5.52213 3.62209 5.50033 3.73207 5.5 3.84321V19.1568C5.50175 19.38 5.58951 19.5936 5.74435 19.7514C5.89918 19.9091 6.10865 19.9984 6.3275 20H19.6725C19.782 19.9992 19.8903 19.9764 19.9911 19.9329C20.092 19.8895 20.1835 19.8261 20.2603 19.7465C20.3372 19.667 20.3979 19.5727 20.439 19.4692C20.4801 19.3657 20.5009 19.2549 20.5 19.1432V7.25001L16.3333 3.00001H6.3325ZM11.7492 7.675C11.7492 9.01545 11.37 10.5965 10.7292 12.0551C10.0858 13.5196 9.21749 14.7725 8.31249 15.5112L9.29583 16.8822C11.735 15.223 14.4358 14.0857 17.0491 14.4665L17.43 12.8184C15.2033 12.0619 13.4167 9.7915 13.4167 7.675H11.7492ZM12.2492 12.7512C12.4725 12.2438 12.67 11.7176 12.8367 11.1847C13.2348 11.8043 13.713 12.3664 14.2583 12.8558C13.44 13.0054 12.6383 13.251 11.8625 13.5638C12.0003 13.2969 12.1286 13.026 12.2492 12.7512Z"
                    fill="black"
                  />
                </svg>
                <p class="text-gray-700 font-medium text-sm">Dosya</p>
              </div>
            </div>
            <div
              v-if="!chat.isOpenUploadLine"
              class="bg-gray-200 py-[4px] px-[8px] rounded-full flex items-center"
            >
              <div
                @click="chat.isOpenUploadLine = true"
                v-if="!chat.message"
                class="cursor-pointer mr-2"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_4058_1410)">
                    <path d="M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z" fill="black" />
                  </g>
                  <defs>
                    <clipPath id="clip0_4058_1410">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <textarea
                rows="1"
                v-model.trim="chat.message"
                @keyup.enter="messageSend(chat.studentId)"
                placeholder="Mesaj yazın..."
                class="bg-gray-100 w-full border-gray-200 px-4 py-2 pr-8 resize-none rounded-full &:placeholder-gray-400 font-medium text-md text-gray-700"
              />
            </div>
            <BaykusButton
              :disabled="
                !chat.message &&
                (selectedChatId !== chat.studentId ||
                  (selectedChatId === chat.studentId && !selectedFile))
              "
              :isLoading="isLoadingUpload === chat.studentId"
              @click.prevent="messageSend(chat.studentId)"
              type="primary"
              class="w-full mt-2"
              size="sm"
            >
              Gönder
            </BaykusButton>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-gray-50 w-[350px] rounded-tl-xl rounded-tr-xl shadow-xl border border-gray-200">
      <div @click.prevent="toggleList" class="cursor-pointer flex items-center justify-between">
        <div class="flex px-4 py-3 items-center gap-3">
          <BaykusAvatar :src="getUserData.profilePhotoUrl" width="40" height="40" />
          <h2 class="text-base font-semibold text-gray-700">Mesajlar</h2>
        </div>
        <div :class="{ 'rotate-180': openList }" class="px-4 py-3 text-gray-700">
          <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.5 16.25L13 9.75L19.5 16.25"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </div>
      </div>
      <div v-if="openList">
        <div v-if="messagesList.length > 0" class="border-t border-b border-gray-200 px-4 py-3">
          <div class="relative">
            <input
              v-model.trim="search"
              @input="onSearch"
              type="text"
              placeholder="Kullanıcı Ara"
              class="bg-gray-100 w-full border-gray-200 px-4 pr-8 py-3 rounded-md &:placeholder-gray-400 font-semibold text-gray-700"
            />
            <span class="icon block absolute top-1/2 -translate-y-1/2 right-[10px]">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.881 18.1191L16.8815 18.1186L16.8865 18.1253C16.9672 18.2053 17.0628 18.2688 17.1678 18.3123C17.2741 18.3563 17.3881 18.379 17.5033 18.379C17.6184 18.379 17.7324 18.3563 17.8387 18.3123C17.9451 18.2682 18.0417 18.2036 18.1231 18.1222C18.2045 18.0408 18.2691 17.9442 18.3132 17.8378C18.3572 17.7315 18.3799 17.6175 18.3799 17.5024C18.3799 17.3872 18.3572 17.2732 18.3132 17.1669C18.2691 17.0605 18.2045 16.9639 18.1231 16.8825L14.4091 13.1692L14.3703 13.1305L14.4037 13.087C15.5064 11.6499 16.0213 9.84722 15.8438 8.04453C15.6663 6.24185 14.8097 4.57417 13.4479 3.37981C12.086 2.18544 10.3208 1.55382 8.51039 1.61307C6.69995 1.67233 4.97984 2.41801 3.69899 3.69887C2.41813 4.97972 1.67245 6.69983 1.6132 8.51026C1.55394 10.3207 2.18556 12.0859 3.37993 13.4477C4.57429 14.8096 6.24197 15.6662 8.04465 15.8437C9.84734 16.0212 11.65 15.5063 13.0871 14.4036L13.1306 14.3702L13.1693 14.4089L16.881 18.1191ZM8.75014 3.37502L8.7502 3.37502C10.1753 3.37648 11.5416 3.94324 12.5492 4.95092C13.5569 5.95859 14.1237 7.32488 14.1251 8.74995L14.1251 8.75002C14.1251 9.81309 13.8099 10.8523 13.2193 11.7362C12.6287 12.6201 11.7892 13.309 10.8071 13.7159C9.82491 14.1227 8.74417 14.2291 7.70153 14.0217C6.65888 13.8143 5.70115 13.3024 4.94944 12.5507C4.19773 11.799 3.68581 10.8413 3.47842 9.79863C3.27102 8.75598 3.37746 7.67524 3.78428 6.69309C4.19111 5.71094 4.88003 4.87148 5.76395 4.28087C6.64786 3.69025 7.68706 3.37502 8.75014 3.37502Z"
                  fill="#9D9D9A"
                  stroke="#9D9D9A"
                  stroke-width="0.125"
                />
              </svg>
            </span>
          </div>
        </div>
        <div @scroll="onScroll" class="w-full h-[450px] overflow-auto">
          <div
            v-if="messagesList.length === 0"
            class="flex flex-col justify-center w-full border-t border-t-gray-200 items-center gap-3 px-4 pb-3 pt-[100px]"
          >
            <svg
              width="71"
              height="48"
              viewBox="0 0 71 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M67.7304 14.6654C65.8048 11.9718 63.0665 9.83002 60.0117 8.63891C58.2498 7.95049 56.3676 7.56254 54.4529 7.46966C54.4257 7.46966 54.4203 7.4369 54.442 7.42595C57.8516 5.92343 62.0519 4.80334 67.1359 4.65036C68.3468 4.61211 69.3997 3.68874 69.476 2.47579C69.5634 1.09348 68.4505 -0.0320654 67.0976 0.000701045C47.1704 0.568943 38.8625 14.1737 38.4263 14.9113C38.0389 15.4358 37.6733 15.9713 37.3571 16.534C36.0368 18.8671 35.3495 21.5115 35.3386 24.1013C35.3386 21.5115 34.6514 18.8671 33.3311 16.534C33.0149 15.9767 32.6492 15.4358 32.2619 14.9113C31.8202 14.1573 23.5066 0.568943 3.59044 0.000701045C2.23216 -0.0320654 1.1248 1.08799 1.21206 2.47579C1.28845 3.68329 2.34125 4.61211 3.55228 4.65036C8.63635 4.80883 12.8368 5.92343 16.2515 7.42595C16.2732 7.4369 16.2678 7.46966 16.2407 7.46966C14.3259 7.56254 12.4383 7.95049 10.6765 8.63891C7.62716 9.83002 4.88874 11.9718 2.96312 14.6654C0.955688 17.4738 -0.0371311 20.8395 0.00106119 24.6695C0.0228854 26.9971 0.590194 29.1334 1.6921 31.0183C3.2686 33.7231 5.85428 35.7829 8.78363 36.6788C10.9929 37.351 13.1751 37.3401 15.286 37.3235C15.6351 37.3235 15.9842 37.3235 16.3332 37.3235C16.7534 37.3235 17.1788 37.329 17.6044 37.3401H17.9809C18.6028 37.3564 19.2355 37.3672 19.879 37.3672C21.363 37.3672 22.8959 37.3073 24.4121 37.0504C24.4232 37.0504 24.4287 37.0504 24.4341 37.0613C25.1051 37.87 25.7761 38.6785 26.4471 39.4927C27.6797 40.9788 28.9126 42.4706 30.1509 43.9567L31.542 45.6339C32.0928 46.2949 32.5729 47 33.3365 47.448C33.9312 47.7976 34.6185 47.9945 35.3112 47.9999C36.7515 48.0107 37.8532 47.2348 38.7045 46.1475C38.999 45.7704 39.3207 45.4045 39.6263 45.0386C40.7881 43.6396 41.9501 42.2355 43.1121 40.8368C44.0722 39.6784 45.0323 38.5202 45.9924 37.3618C46.0741 37.2635 46.1558 37.1653 46.2378 37.0613C46.2378 37.0559 46.254 37.0504 46.2595 37.0504C47.7869 37.3127 49.3254 37.3727 50.8145 37.3727C51.4581 37.3727 52.0965 37.3618 52.713 37.351H53.0892C53.5148 37.3401 53.9401 37.329 54.3603 37.329C54.7094 37.329 55.0585 37.329 55.4075 37.329C57.5188 37.3455 59.7061 37.3564 61.9099 36.6845C64.8338 35.7937 67.4196 33.734 69.0015 31.0295C70.0979 29.1497 70.6706 27.0134 70.6926 24.6805C70.7309 20.8449 69.7325 17.4793 67.7304 14.6763V14.6654ZM18.0572 32.6904H17.6752C17.2279 32.6738 16.786 32.6684 16.3444 32.6684C16.2732 32.6684 16.2024 32.6684 16.1316 32.6684C15.8371 32.6684 15.548 32.6684 15.2532 32.6684C13.4096 32.685 11.6639 32.6904 10.1256 32.2259C8.30359 31.674 6.6889 30.3739 5.69063 28.6689C5.00332 27.4942 4.64873 26.1338 4.63237 24.6204C4.60509 21.7956 5.3088 19.3533 6.73255 17.3645C8.13994 15.3921 10.1419 13.8295 12.3621 12.9607C15.9025 11.5784 20.1464 11.8297 23.7194 13.6382C26.1089 14.8457 28.089 16.687 29.2945 18.8179C30.5599 21.0526 31.0018 23.6642 30.5054 25.9918C30.0035 28.3575 28.4598 30.483 26.4797 31.5374C24.123 32.7941 21.1773 32.7395 18.0517 32.685L18.0572 32.6904ZM34.5859 43.1151L29.998 37.2744V37.2415C29.998 37.2415 35.3332 33.3789 35.3441 33.3789L40.6189 37.3073V37.3347L36.1022 43.1096C35.7151 43.6016 34.9676 43.607 34.5805 43.1096L34.5859 43.1151ZM64.9975 28.6689C63.9991 30.3739 62.3846 31.674 60.5627 32.2259C59.0296 32.6958 57.2786 32.685 55.435 32.6684C55.0693 32.6684 54.704 32.6684 54.3383 32.6684C53.8967 32.6684 53.4548 32.6738 53.0075 32.685H52.6256C49.4999 32.745 46.5543 32.7995 44.1976 31.5428C42.2175 30.4884 40.6735 28.363 40.1719 25.9973C39.6754 23.6697 40.1174 21.0526 41.3828 18.8234C42.5937 16.6925 44.5738 14.8512 46.9579 13.6437C49.0035 12.6111 51.2673 12.0865 53.4982 12.0865C55.1622 12.0865 56.8041 12.3816 58.3152 12.9717C60.5353 13.8404 62.5372 15.403 63.9446 17.3755C65.3632 19.3643 66.0721 21.8065 66.045 24.6313C66.0284 26.1392 65.6739 27.5054 64.9867 28.6801L64.9975 28.6689ZM24.3141 25.7514C23.2612 25.7514 22.4048 24.8936 22.4048 23.8391C22.4048 21.2274 20.2827 19.102 17.6752 19.102C15.0678 19.102 12.9457 21.2274 12.9457 23.8391C12.9457 24.8936 12.0893 25.7514 11.0366 25.7514C9.98372 25.7514 9.1273 24.8936 9.1273 23.8391C9.1273 19.1184 12.9622 15.2774 17.6752 15.2774C22.3885 15.2774 26.2234 19.1184 26.2234 23.8391C26.2234 24.8936 25.3667 25.7514 24.3141 25.7514ZM59.6627 25.7514C58.6097 25.7514 57.7533 24.8936 57.7533 23.8391C57.7533 21.2274 55.6312 19.102 53.0238 19.102C50.4163 19.102 48.2942 21.2274 48.2942 23.8391C48.2942 24.8936 47.4378 25.7514 46.3852 25.7514C45.3322 25.7514 44.4759 24.8936 44.4759 23.8391C44.4759 19.1184 48.3108 15.2774 53.0238 15.2774C57.7368 15.2774 61.5717 19.1184 61.5717 23.8391C61.5717 24.8936 60.7153 25.7514 59.6627 25.7514Z"
                fill="#5E36FE"
              />
            </svg>
            <p class="text-md text-gray-700">Henüz bir mesajınız yok.</p>
          </div>
          <template v-if="messagesList.length > 0">
            <div
              v-for="item in messagesList"
              :key="item.studentId"
              @click="onClickChatPopup(item)"
              class="flex cursor-pointer w-full items-center gap-3 px-4 py-3 border-b border-b-gray-200"
            >
              <BaykusAvatar :src="item.profilePhoto" width="40" height="40" />
              <div class="flex-1">
                <div class="flex flex-1 items-center justify-between">
                  <h3 class="text-base font-semibold text-gray-700">{{ item.studentFullName }}</h3>
                  <span class="text-gray-500 text-sm font-medium block">{{
                    DateTime.fromISO(item.lastMessageDate).toFormat('dd.MM HH:mm')
                  }}</span>
                </div>
                <p class="text-sm text-gray-500 break-all line-clamp-2 overflow-hidden">
                  {{
                    item.lastMessage
                      ? item.lastMessage
                      : !item.lastMessage && item.lastMessageDate
                        ? 'Dosya'
                        : ''
                  }}
                </p>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
